import type { Direction } from "../../../engine/direction";
import { BurstParticle } from "./burstParticle";

export class BloodParticle extends BurstParticle {
	constructor(originX: number, originY: number, direction?: Direction) {
		super(
			originX,
			originY,
			{
				ttl: [250, 600],
				size: [0.35, 0.25],
				color: { r: 180, g: 20, b: 20 },
				speed: [2, 4],
				gravity: 3.0,
			},
			direction,
		);
	}
}
